module.exports = __webpack_public_path__ + "img/btn-save.10146546.svg";